<template>
  <div class="editor-setting-width">
    <div class="editor-setting-header" >
      <!-- <span>{{ $t('message.workBench.body.script.setting.header') }}</span> -->
      <span>设置自定义参数</span>
      <Icon
        type="ios-close"
        @click="$emit('custom-setting-close')"/>
    </div>
    <div class="editor-setting-content">
      <!-- <custom-variable
        ref="customVariable"
        :script="script"></custom-variable> -->
        <common-form
          ref="customForm"
          :title="$t('message.workBench.body.setting.customVariable.title')"
          :list="paramList" 
          @custom-setting-close="$emit('custom-setting-close')" 
          @custom-setting-save="$emit('custom-setting-save')"
          ></common-form>
      
    </div>
  </div>
</template>
<script>
// import customVariable from '../setting/customVariable.vue';
import commonForm from '@dss/js/component/dynamicForm/form';

import { isEqual } from 'lodash';
export default {
  name: 'customParam',
  components: {
    commonForm
  },
  props: {
    paramList: {
      type: Array,
      required: true,
    },
    
  },
  data() {
    return {
      // origin: null,
    };
  },
  /*watch: {
    'paramList': {
      handler: function(val) {
        this.work.unsave = !isEqual(JSON.parse(this.origin), val);
      },
      deep: true,
    },
  },
  mounted() {
    this.origin = JSON.stringify(this.paramList);
  },*/
};
</script>
<style lang="scss" scoped>

.editor-setting-width{
    width: 500px;
    background: #f7f7f7;
    border: 1px solid #dcdee2;
    overflow-y: auto;
    position: absolute;
    top: 32px;
    right: 35%;
    height:300px;
    /* bottom:0; */
    
}

.editor-setting-width .editor-setting-header {
    border-bottom: 1px solid #e8eaec;
    padding: 10px 16px;
    line-height: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
}

.ivu-icon {
    display: inline-block;
    font-family: Ionicons;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-rendering: optimizeLegibility;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: -0.125em;
    text-align: center;
    font-size: 26px;
  }

</style> 
  
